import { render } from "./lesson-home-skeleton.vue?vue&type=template&id=baccd99c&scoped=true"
import script from "./lesson-home-skeleton.vue?vue&type=script&lang=js"
export * from "./lesson-home-skeleton.vue?vue&type=script&lang=js"

import "./lesson-home-skeleton.vue?vue&type=style&index=0&id=baccd99c&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baccd99c"]])

export default __exports__